import {combineReducers} from '@reduxjs/toolkit';

import {assignUserEntitlementsStateSlice} from './slices/assign-user-entitlements-state.slice';
import {assignUserEntitlementsSlice} from './slices/assign-user-entitlements.slice';

export const assignUserEntitlementsReducer = combineReducers({
    result: assignUserEntitlementsSlice.reducer,
    state: assignUserEntitlementsStateSlice.reducer,
});
